module.exports = __webpack_public_path__ + "static/media/loading-404.f5f2108d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/images/loading-404.svg
// module id = 463
// module chunks = 13 14 16